import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './components/home/Home';
import Rates from './components/rate/Rates';

function App() {
  return (
    <Router>
      <div className="App font-inter bg-[#FFFDFA]">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rates" element={<Rates />} />
        </Routes>
        <Footer />
      </div>
    </Router >
  );
}

export default App;
